import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { SOCKET_HOST } from "../../helpers/constants";

import Summary from "./components/Summary";

const SummaryPage = ({ history }) => {

  const [response, setResponse] = useState(null);

  const { rut } = JSON.parse(localStorage.getItem('step2'));

  useEffect(() => {
    const socket = io(SOCKET_HOST);
    socket.on(`SIM_${rut?.replace(/[$.]/g, '') || ''}`, data => {
      setResponse(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Summary history={history} socketRes={response} />
  );
}

export default SummaryPage;
